var _defs, _circle, _path, _path2, _g, _circle2, _g2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\xCE\\xD3\\xC8_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1248 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;}.cls-4{fill:url(#linear-gradient);}.cls-5{clip-path:url(#clippath);}.cls-6{fill:#fff;}.cls-7{fill:#65707c;}.cls-8{fill:#c9e4d4;}.cls-2{stroke-linecap:round;stroke-width:9.88px;}.cls-2,.cls-3{stroke:#d3d2d8;stroke-miterlimit:10;}.cls-9{fill:url(#linear-gradient-3);}.cls-10{fill:url(#linear-gradient-4);}.cls-11{fill:url(#linear-gradient-2);}.cls-12{fill:url(#linear-gradient-6);}.cls-13{fill:url(#linear-gradient-7);}.cls-14{fill:url(#linear-gradient-5);}.cls-3{stroke-width:9px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 609.75,
    cy: 523,
    r: 415.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1253.38,
    y1: 1672.32,
    x2: 1070.31,
    y2: 1766.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9e4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d1e8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#dfefe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4f2e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -426.89,
    y1: 1390.96,
    x2: -1110.16,
    y2: 802.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5e2cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4f2e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1176.75,
    y1: 1418.88,
    x2: 2030.02,
    y2: 1023.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4dac0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#cce5d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e3f0e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#f1f7f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6faf7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 366.01,
    y1: 1492.46,
    x2: -454.57,
    y2: 478.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4dac0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#c5e2cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6faf7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 620.07,
    y1: 943.42,
    x2: 624.43,
    y2: 621.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4f2e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f1f7f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6faf7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -5146.53,
    y1: 472.05,
    x2: -5148.61,
    y2: 603.38,
    gradientTransform: "translate(-4537) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d8691"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8d9a9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#b8cfc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9e4d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -5145.52,
    y1: 511.19,
    x2: -5148.39,
    y2: 666.93,
    gradientTransform: "translate(-4537) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#65707c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#68747f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#728088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#849497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9cb0ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#bbd4c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9e4d4"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 608.75,
    cy: 523,
    r: 415.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m410.29,934.15c-106.95-51.46-190.73-143.41-231.46-255.97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m980.17,259.8c52.64,74.35,83.58,165.16,83.58,263.2,0,177.72-101.66,331.69-250.01,406.93"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1034.25,
    cy: 1784.5,
    r: 1376.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: -184.75,
    cy: 1599.5,
    r: 1376.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 1283.25,
    cy: 1369.5,
    r: 1074.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 433.25,
    cy: 1575.5,
    r: 1074.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m1684.75,1670.5c0,593.43-481.07,1074.5-1074.5,1074.5S-464.25,2263.93-464.25,1670.5-34.24,643.03,519.75,600c23.87,9.74,62.6,3,91,3s68.32-.33,95-3c553.61,43.42,979,505.74,979,1070.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m527.07,600h-14.03c-.4,10.1-1.39,22.9-3.81,37.5-5.03,30.55-16.27,68.98-41.17,107-26.59,40.58-56.92,62.66-63,67-42.9,30.57-92.43,48.61-105.31,53.5-58,22-127,40-309.25,105H54.89c132.86-45,200.86-63,249.86-81,14.19-5.21,64.56-28.42,113.31-63.5,10.64-7.66,44.78-33.54,72-80,23.11-39.46,32.11-78.21,35.38-108h0c1.67-15.2,1.84-28.07,1.63-37.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m913.75,864c-13.1-4.28-55.61-21.93-98.5-52.5-6.09-4.34-36.42-26.42-63-67-24.9-38.02-36.14-76.45-41.18-107-2.41-14.6-3.41-27.4-3.8-37.5h-14.03c-.21,9.43-.04,22.3,1.63,37.5,3.26,29.79,12.26,68.54,35.38,108,27.21,46.46,61.35,72.34,72,80,48.74,35.08,96.63,65.74,111.5,68.5,49.09,9.1,116.32,16.56,241,81l75.06-5c-178.06-66-265.56-89.5-316.06-106Z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 608.75,
    cy: 523,
    r: 415.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m550.75,600h9.2c5.87-9.81,11.97-21.55,17.38-35.2,7.95-20.05,12.1-38.4,14.32-53.3h-7.16c-2.69,14.83-7.28,32.78-15.34,52.3-5.79,14.01-12.23,26.09-18.41,36.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m596.06,511.5h4c2.16-4.64,4.58-11.07,6-19,1.33-7.51,1.35-14.05,1-19h-2c.07,5.02-.3,11.57-2,19-1.83,7.95-4.59,14.36-7,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m600.06,511.5h20.19c-2.16-4.64-4.59-11.07-6-19-1.34-7.51-1.35-14.05-1-19h-6.19c.35,4.95.33,11.49-1,19-1.42,7.93-3.84,14.36-6,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m613.25,473.5c-.35,4.95-.34,11.49,1,19,1.41,7.93,3.84,14.36,6,19h4c-2.42-4.64-5.18-11.05-7-19-1.7-7.43-2.08-13.98-2-19h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m635.82,511.5h-7.16c2.22,14.9,6.37,33.25,14.32,53.3,5.41,13.65,11.5,25.39,17.38,35.2h9.2c-6.19-10.12-12.62-22.2-18.41-36.2-8.06-19.52-12.65-37.46-15.34-52.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m610.41,511h-.5v-2h.5v2Zm0-5h-.5v-3h.5v3Zm0-6h-.5v-3h.5v3Zm0-6h-.5v-3h.5v3Zm0-6h-.5v-3h.5v3Zm0-6h-.5v-3h.5v3Zm0-6h-.5v-3h.5v3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m577.34,564.8c7.95-20.05,12.1-38.4,14.32-53.3h37.01c2.22,14.9,6.37,33.25,14.32,53.3,5.41,13.65,11.5,25.39,17.38,35.2l-2.17,2.93h-96.06l-2.17-2.93c5.87-9.81,11.97-21.55,17.38-35.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m309.75,882c14.02-5.64,59.56-21.42,108.31-56.5,10.64-7.66,44.78-33.54,72-80,23.11-39.46,32.11-78.21,35.38-108h0c1.67-15.2,1.84-28.07,1.63-37.5h166.17c-.21,9.43-.04,22.3,1.63,37.5,3.26,29.79,12.26,68.54,35.38,108,27.21,46.46,61.35,72.34,72,80,48.74,35.08,96.23,50.5,110.5,55.5,38.5,13.5,106,34,217.9,71.42,9.3,3.11,5.69,17.58-4.11,17.58h-388.54s-270.26,0-270.26,0H93.77c-9.8,0-13.54-14.89-4.11-17.58,112-31.9,171.96-51.06,220.09-70.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m611.16,592h-2v-9h2v9Zm0-18h-2v-9h2v9Zm0-18h-2v-9h2v9Zm0-18h-2v-9h2v9Zm0-18h-2v-9h2v9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 606.93,
    y: 606.13,
    width: 6.46,
    height: 22.34,
    transform: "translate(1220.31 1234.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 606.93,
    y: 648.66,
    width: 6.46,
    height: 37.38,
    transform: "translate(1220.31 1334.7) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 606.93,
    y: 708.8,
    width: 6.46,
    height: 26.85,
    transform: "translate(1220.31 1444.46) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 606.93,
    y: 758.42,
    width: 6.46,
    height: 16.54,
    transform: "translate(1220.31 1533.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 606.93,
    y: 797.09,
    width: 6.46,
    height: 10.31,
    transform: "translate(1220.31 1604.48) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 603.99,
    y: 826.73,
    width: 12.33,
    height: 10.31,
    transform: "translate(1220.31 1663.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 601.84,
    y: 851.65,
    width: 16.63,
    height: 10.31,
    transform: "translate(1220.31 1713.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 600.27,
    y: 875.7,
    width: 19.76,
    height: 10.31,
    transform: "translate(1220.31 1761.72) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 597.93,
    y: 899.76,
    width: 24.46,
    height: 10.31,
    transform: "translate(1220.31 1809.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 592.84,
    y: 925.33,
    width: 34.63,
    height: 14.6,
    transform: "translate(1220.31 1865.25) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 587.74,
    y: 951.1,
    width: 44.84,
    height: 18.9,
    transform: "translate(1220.31 1921.1) rotate(180)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m932.27,202.66c10.53,10.67,17.03,17.68,26.48,29.34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m892.4,166.73c4.97,3.98,9.86,8.06,14.66,12.24"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapEmpty);
export default __webpack_public_path__ + "static/media/MapEmpty.90ea2f83bf8cbdaf0916bc5660a24c4f.svg";
export { ForwardRef as ReactComponent };